import React from 'react';
import SafeIcon from '../common/SafeIcon';

export default function TopBar({ title }) {
  return (
    <header className="h-20 px-6 flex items-center justify-between bg-vinyl-900/80 backdrop-blur-md sticky top-0 z-30">
      <h2 className="text-2xl font-display font-bold text-white tracking-wide text-glow-aqua">{title}</h2>
      
      <div className="flex items-center gap-4">
        <div className="relative hidden md:block">
          <SafeIcon icon="FiSearch" className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
          <input 
            type="text" 
            placeholder="Search network..." 
            className="bg-vinyl-800 border border-vinyl-700 text-white text-sm rounded-full pl-10 pr-4 py-2 focus:outline-none focus:border-plasma focus:ring-1 focus:ring-plasma transition-all w-64"
          />
        </div>
        
        <button className="w-10 h-10 rounded-full bg-vinyl-800 border border-vinyl-700 flex items-center justify-center text-gray-300 hover:text-plasma transition-colors relative">
          <SafeIcon icon="FiBell" />
          <span className="absolute top-2 right-2 w-2 h-2 bg-plasma rounded-full glow-plasma" />
        </button>
        
        <div className="w-10 h-10 rounded-full bg-vinyl-700 overflow-hidden cursor-pointer border-2 border-transparent hover:border-aqua transition-all">
          <img src="https://images.unsplash.com/photo-1570295999919-56ceb5ecca61?q=80&w=100&auto=format&fit=crop" alt="Profile" className="w-full h-full object-cover" />
        </div>
      </div>
    </header>
  );
}